"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var commonweb_utils_1 = require("commonweb-utils");
var utils_1 = require("../../../common/utils/name/utils");
function UpdateName(_a) {
    var content = _a.content, account = _a.account, links = _a.links, fpti = _a.fpti, features = _a.features, transitionOutHandler = _a.transitionOutHandler;
    var nameInfo = commonweb_utils_1.objectUtils.safeGet(account, "name") || {};
    var nameFpti = fpti.nameChange;
    var nameContent = content.name;
    var allowedMinorNameChange = commonweb_utils_1.objectUtils.safeGet(nameInfo, "allowMinorNameChange");
    var minorNameChangeEnabled = utils_1.isMinorNameChangeEnabled(features);
    var legalChangeLink = links.legalNameChangeUrl.linkUrl;
    var majorChangeLink = links.majorNameChangeUrl.linkUrl;
    var minorChangeLink = links.minorNameChangeUrl.linkUrl;
    var nameComponent = (React.createElement("div", null,
        React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, nameContent.header.title),
        React.createElement(pp_react_1.Link, { className: "choiceBox", href: legalChangeLink, "data-name": nameFpti.legalChange },
            React.createElement(pp_react_1.Icon, { name: "user", className: "nameIcon", size: "xl2" }),
            React.createElement("span", { className: "choiceTitle" },
                React.createElement(pp_react_1.Text, { size: "xl" }, nameContent.legal.title)),
            React.createElement("span", { className: "choiceComment" },
                React.createElement(pp_react_1.Text, { size: "sm" }, nameContent.legal.comment))),
        React.createElement(pp_react_1.Link, { className: "choiceBox", href: majorChangeLink, "data-name": nameFpti.majorChange },
            React.createElement(pp_react_1.Icon, { name: "contact-info", className: "nameIcon", size: "xl2" }),
            React.createElement("span", { className: "choiceTitle" },
                React.createElement(pp_react_1.Text, { size: "xl" }, nameContent.update.title)),
            React.createElement("span", { className: "choiceComment" },
                React.createElement(pp_react_1.Text, { size: "sm" }, nameContent.update.comment))),
        minorNameChangeEnabled && allowedMinorNameChange == true ? (React.createElement(pp_react_1.Link, { className: "choiceBox", href: minorChangeLink, "data-name": nameFpti.minorChange },
            React.createElement(pp_react_1.Icon, { name: "edit", className: "nameIcon", size: "xl2" }),
            React.createElement("span", { className: "choiceTitle" },
                React.createElement(pp_react_1.Text, { size: "xl" }, nameContent.minor.title)),
            React.createElement("span", { className: "choiceComment" },
                React.createElement(pp_react_1.Text, { size: "sm" }, nameContent.minor.comment)))) : null));
    return React.createElement("div", { className: "generic-container" }, nameComponent);
}
var mapStateToProps = function (_a) {
    var content = _a.content, account = _a.account, links = _a.links, fpti = _a.fpti, features = _a.features;
    return ({
        content: content,
        account: account,
        links: links,
        fpti: fpti,
        features: features,
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(UpdateName);
